import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-379fc7ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["name", "value", "checked"];
export default /*#__PURE__*/ _defineComponent({
    props: {
        group: null,
        value: null,
        title: null,
        checked: { type: Boolean }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const onClick = () => {
            emit('click', props.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("input", {
                    type: "radio",
                    name: props.group,
                    value: props.value,
                    onClick: onClick,
                    checked: __props.checked
                }, null, 8, _hoisted_1),
                _createTextVNode(" " + _toDisplayString(props.title), 1)
            ], 64));
        };
    }
});
